/**
 * @desc 仓库审核
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.CabinSelfWarehouseExamineRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/cabinMasterSelfWhole/warehouseExamine`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
